import { select } from 'core/middlewares/utilities';

import type { RootState } from 'core/store';

/**
 * Get the routes from router
 *
 */
export function* getRoutes() {
  const data: RootState['settings']['data'] = yield select(
    ({ settings }: RootState) => settings.data,
  );

  return data.routes;
}

export type SettingsRoutes = RootState['settings']['data']['routes'];

/**
 * Get feature toggle from settings
 *
 */
export function* getFeatureToggle(key: string) {
  const featureToggle: RootState['settings']['data']['featureToggle'] = yield select(
    ({ settings }: RootState) => settings.data.featureToggle,
  );

  return featureToggle[key] || false;
}
